import { render, staticRenderFns } from "./SpareParts.vue?vue&type=template&id=fed38456&scoped=true&"
import script from "./SpareParts.vue?vue&type=script&lang=js&"
export * from "./SpareParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed38456",
  null
  
)

export default component.exports